import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Validators } from 'ngx-editor';
import { ToastrService } from 'ngx-toastr';
import { Helps } from 'src/app/libs/helps';
import { Users } from 'src/app/models/interfaces/users';
import { ApiEntryControlService } from 'src/app/modules/entry-control/api-entry-control.service';
import { Facility } from 'src/app/modules/entry-control/interfaces/facility';
import { RoundsConfiguration } from 'src/app/modules/entry-control/interfaces/rounds_configuration';
import { RoundsTags } from 'src/app/modules/entry-control/interfaces/rounds_tags';
import { RoundsType } from 'src/app/modules/entry-control/interfaces/rounds_type';
import { RoundNotificationService } from 'src/app/modules/entry-control/round-notification.service';

@Component({
  selector: 'app-add-scheduled-rounds',
  templateUrl: './add-scheduled-rounds.component.html',
  styleUrls: ['./add-scheduled-rounds.component.css']
})
export class AddScheduledRoundsComponent implements OnInit {
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private modal: NgbModal,
    private formBuilder: FormBuilder,
    private helps: Helps,
    private roundNotificationService: RoundNotificationService
  ) { }
  primaryForm: FormGroup;
  level: number;
  sendProgram:number=0;
  sendInmediate:number=0;

  emailNotification: string;
  ngOnInit(): void {
    this.getFacilities();
    this.getRoundsType();
    let data = this.helps?.getToken()?.data as Users;
    this.sendInmediate=data?.send_rounds_immediate;
    this.sendProgram=data?.send_rounds_program;
    this.level = this.helps.getToken()?.level;
    this.primaryForm = this.formBuilder.group({
      facility_id: [0, Validators.required],
      rounds_type_id: [0, Validators.required],
      start_date: [null],
      end_date: [null],
      repeats: [0],
      repeat_date: [null],
      email_notification: ['', Validators.required],
      tags: [],
      available_days: [''],
      xdays: [[]]
    }, { validators: this.dateComparisonValidator });
    this.primaryForm.get("email_notification")?.setValue(data?.email);
  }

  day: number;
  allDays: string[] = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
  // Mapeo de nombres de días a números de día de la semana
  dayNameToNumber: { [key: string]: number } = {
    'Lunes': 1,
    'Martes': 2,
    'Miércoles': 3,
    'Jueves': 4,
    'Viernes': 5,
    'Sábado': 6,
    'Domingo': 7
  };

  toggleDaySelection(day: any): void {
    const xdaysControl = this.primaryForm.get('xdays');
    const currentValue = [...(xdaysControl.value || [])]; // Crea una copia

    const selectedIndex = currentValue.indexOf(day);

    if (selectedIndex === -1) {
      // Si el día no está seleccionado, agrégalo
      currentValue.push(day);
    } else {
      // Si el día está seleccionado, retíralo
      currentValue.splice(selectedIndex, 1);
    }

    xdaysControl.setValue(currentValue);
  }


  /**
   * Hago referencia a la ventana actual
   */
  @Input()
  modalRef: NgbModalRef | undefined;
  @Input()
  facilityId: number = 0;
  @Output()
  success = new EventEmitter<boolean>();
  @Output()
  onData = new EventEmitter<RoundsConfiguration>();

  facilities: Facility[];
  types: RoundsType[];
  facility: Facility;
  tagsAvailable: RoundsTags[] = [];
  tagsSelected: RoundsTags[] = [];
  showMaps: boolean = false;
  
  create() {
    if ((this.level == 2) && (this.primaryForm.get('rounds_type_id')?.value == 2)) {
      this.toast.warning("Solo puedes enviar rondas inmediatas");
      return;
    }

    const selectedDays = this.primaryForm.value.xdays as string[];
    const daysNumbers = selectedDays.map(day => this.dayNameToNumber[day]).join(',');
    this.primaryForm.get('available_days')?.setValue(daysNumbers);
    
    const selectedTagIds = this.tagsSelected.map(tag => tag.id).join(',');
    this.primaryForm.get('tags')?.setValue(selectedTagIds);
    if (this.tagsSelected?.length <= 0) {
      this.toast.warning("Debe seleccionar al menos 1 tag");
      return;
    }



    this.api.createRoundsConfiguration(this.primaryForm).subscribe(
      (rs) => {
        this.toast.success(rs.msg, 'Gestión Rondas');
        this.success.emit(true);
        let data = rs.data as RoundsConfiguration;
        this.onData.emit(data);
        this.roundNotificationService.notifyRoundCreated(data);
        if (this.modalRef != null) {
          this.modalRef.close();
        } else {
          this.modal.dismissAll();
        }
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.error.msg, { enableHtml: true });
      }
    );
  }
  getFacilities() {
    this.api.getAllFacility().subscribe(rs => {
      this.facilities = rs.data as Facility[];
    });
  }
  getRoundsType() {
    this.api.getAllRoundsType().subscribe(rs => {
      let types = rs.data as RoundsType[];
      this.types = types.filter(t => t.id != 1);
      if (this.level == 2) {
        if(this.sendInmediate==0){
          this.types = this.types.filter(x => x.id != 3);
        }
       if(this.sendProgram==0){
        this.types = this.types.filter(x => x.id != 2);
       }
      }

    });
  }
  openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: size,
    });
  }
  // Validación personalizada para comparar las fechas y horas
  dateComparisonValidator(formGroup: FormGroup) {
    const startDatetime = formGroup.get('start_date').value;
    const endDatetime = formGroup.get('end_date').value;

    if (startDatetime && endDatetime && startDatetime >= endDatetime) {
      return { dateComparison: true };
    }

    return null;
  }
  getRoundsTags() {
    this.api.getAllTagsFacility(this.primaryForm.get('facility_id')?.value).subscribe(rs => {
      let tags = rs.data as RoundsTags[];
      this.tagsAvailable = tags.filter(tag => tag?.state_id != 2);
    }, e => {
      this.tagsAvailable = [];
    });
  }
  getFacility(facility_id: number) {
    this.api.getFacility(facility_id).subscribe(rs => {
      this.facility = rs.data as Facility;
    });
  }
  handleImageError() {
    this.primaryForm?.get('image_path').setValue('assets/images/default.jpg'); // Cambiar la URL a la imagen por defecto
  }
  updateTags() {
    this.tagsSelected=[];
    this.getFacility(this.primaryForm.get('facility_id')?.value);
    this.getRoundsTags();
  }
}


